<template>
    <div>

        <PageHeader>
            {{ $t('configuration') }}
            <template #side>
                <ButtonIcon @click="$router.push({ name: 'WidgetSettings' })">{{ $t('goBack') }}</ButtonIcon>
            </template>
        </PageHeader>

        <ErrorMessage :value="error" :dismissible="false" />

        <Card v-if="!buybox && loading" :loading="loading" />

        <Card v-if="buybox" :loading="loading" :overlay="!!buybox">
            <div class="grid-template">

                <div class="label">{{ $t('identifier') }}</div>
                <div class="value">{{ buybox.id }}</div>

                <div id="form-label-name" class="label">{{ $t('configurationName') }}</div>
                <div class="value">
                    <div v-if="isEditingName" class="d-flex gap-3 width-max-500">
                        <FormValidator :validator="$v.form.name" v-slot="slotProps" :attribute="$t('configurationName')" :msg-props="{ max: 255 }" class="flex-grow-1">
                            <b-input id="form-name" v-model="form.name" :state="slotProps.state" />
                        </FormValidator>
                        <div class="d-flex gap-1 mb-auto">
                            <b-button variant="primary" :disabled="loading" @click="saveName()">{{ $t('save') }}</b-button>
                            <b-button variant="danger" :disabled="loading" @click="setEditingName(false)">{{ $t('cancel') }}</b-button>
                        </div>
                    </div>
                    <template v-else>
                        {{ buybox.name }} <b-link class="ml-3" :disabled="loading" @click="setEditingName(true)">{{ $t('edit').toLowerCase() }}</b-link>
                    </template>
                </div>

                <div class="label">{{ $t('space') }}</div>
                <div class="value">{{ buybox.space.name }} ({{ buybox.space.url }})</div>

            </div>
        </Card>

        <Card v-if="buybox" :loading="loading" overlay class="flex-basis-0 flex-grow-1 width-min-400 mb-auto">

            <b-tabs v-model="tab" class="tab-pills">
                <b-tab v-for="tabName in tabs" :key="tabName" :title="$t(tabName)">
                    <router-view :name="tabName" />
                </b-tab>
            </b-tabs>

        </Card>

    </div>
</template>



<script>
    import { required, maxLength } from 'vuelidate/lib/validators';
    import FormValidator from '@/components/common/FormValidator.vue';

    export const TABS = ['campaigns', 'appearance'];

    export default {
        name: 'BuyboxSettings',
        components: {
            FormValidator,
        },
        provide() {
            return {
                parentComponent: this,
            };
        },
        data() {
            const paramsId = Number.parseInt(this.$route.params.id);
            const paramsTab = this.$route.params.tab;
            const currentTab = TABS.findIndex(tab => paramsTab === tab);
            return {
                tabs: TABS,
                id: paramsId,
                tab: currentTab,
                buyboxRequest: this.$req('buyboxes/buyboxes'),
                isEditingName: false,
                form: {
                    name: '',
                },
            };
        },
        validations: {
            form: {
                name: { required, maxLength: maxLength(255) },
            },
        },
        computed: {
            buybox() {
                return this.buyboxRequest.data;
            },
            loading() {
                return this.buyboxRequest.loading;
            },
            error() {
                return this.buyboxRequest.error;
            },
        },
        watch: {
            tab(tabIndex) {
                if (this.$route.params.tab !== TABS[tabIndex]) {
                    this.$router.push({ params: { ...this.$route.params, tab: TABS[tabIndex] } });
                }
            },
            '$route.params.tab': {
                handler(paramsTab) {
                    const tabIndex = TABS.findIndex(tab => paramsTab === tab);
                    if (tabIndex !== -1) {
                        this.tab = tabIndex;
                    }
                },
            },
            buybox() {
                this.form.name = this.buybox?.name || '';
            },
        },
        methods: {
            fetchBuybox() {
                return this.buyboxRequest.get({ urlParams: { id: this.id } });
            },
            saveName() {
                this.$v.form.$touch();
                if (this.$v.form.$invalid) return;
                this.buyboxRequest.patch({ urlParams: { id: this.id }, requestParams: { name: this.form.name } });
                this.setEditingName(false);
            },
            setEditingName(val) {
                this.isEditingName = val;
                this.$v.form.$reset();
            },
        },
        created() {
            this.fetchBuybox();
        },
    };
</script>



<style lang="scss" scoped>
    ::v-deep .grid-template {
        display: grid;
        grid-template-columns: minmax(160px, max-content) auto;
        gap: 1rem;
        align-items: center;

        .label {
            font-weight: bold;
        }

        @media (max-width: 768px) {
            grid-template-columns: 1fr;
            gap: 0.5rem;
        }
    }
</style>
